import styled from "styled-components";
import { Table as BaseTable } from "antd";
import Typography from "../../../components/shared/typography/Typography";
import Input from "../../../components/shared/input/Input";

export const Container = styled.div`
  padding: 40px;
  flex: 1;
  background-color: ${(props) => props.theme.colors.background};

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    padding: 16px;
  }

  .eventials-button {
    border-radius: 40px;

    :focus {
      border: none;
    }
    :active {
      border: none;
    }
  }

  .ant-table-wrapper {
    margin-top: 32px;
    margin-bottom: 32px;

    .ant-table-thead {
      .ant-table-cell {
        background-color: ${(props) => props.theme.colors.line};
      }
    }

    .ant-table-tbody {
      .ant-table-row {
        background-color: ${(props) => props.theme.colors.offWhite};
      }
    }

    .ant-pagination {
      .ant-pagination-item-active {
        border-color: ${(props) => props.theme.colors.primary};

        a {
          color: ${(props) => props.theme.colors.primary};
        }
      }
    }
  }

  .ant-modal-body {
    display: flex;

    .dashboard-input {
      width: auto;
    }
  }
`;

export const Table = styled(BaseTable)`
  .ant-table-thead > tr > th {
    background: ${(props) => props.theme.colors.white} !important;
  }
`;

export const WhiteLabelName = styled.p`
  font-size: 12px;
  font-weight: 400;
  margin-left: 20%;
  margin-top: 18px;
  padding-right: 64px;
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  @media screen and (max-width: 575px) {
    margin-left: 0;
  }
`;

export const WhiteLabelKind = styled.p`
  font-size: 12px;
  font-weight: 400;
  margin-top: 18px;
  flex: 1;

  @media screen and (max-width: 575px) {
    margin-left: 0;
  }
`;

export const WhiteLabelWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: left;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 900px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const TypographyWrapper = styled.div``;

export const Wrapper = styled.div`
  width: 100%;
  height: fit-content;
  background: ${(props) => props.theme.colors.white};
  border-radius: 8px;
  padding: 60px 56px;

  @media screen and (max-width: 900px) {
    padding: 27px 24px;
  }
`;

export const TableWrapper = styled.div`
  margin-top: 80px;
`;

export const StyledTypography = styled(Typography)`
  &.secondary {
    font-weight: 400 !important;

    @media screen and (max-width: 670px) {
      font-size: 14px !important;
      font-weight: 400 !important;
    }
  }

  &.primary {
    @media screen and (max-width: 670px) {
      font-size: 14px !important;
      font-weight: 700 !important;
    }
  }

  &.tertiary {
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 28px !important;
    color: ${(props) => props.theme.colors.label} !important;
    @media screen and (max-width: 670px) {
      font-size: 10px !important;
      font-weight: 400 !important;
    }
  }
`;

export const StyledInput = styled(Input)`
  width: 340px;
  height: 44px;
  border-radius: 40px;
  @media screen and (max-width: 900px) {
    margin-top: 24px;
    width: 100%;
  }

  & .ant-input {
    font-size: 15px;
    @media screen and (max-width: 670px) {
      font-size: 10px;
    }
  }
`;
export const ModalButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 246px;
  height: 44px;
  padding: 14px 32px;

  color: ${(props) => props.theme.colors.label};
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.75;

  cursor: pointer;

  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 40px;
  background-color: ${(props) => props.theme.colors.white};

  &.red-btn {
    color: ${(props) => props.theme.colors.background};

    border: none;
    background-color: ${(props) => props.theme.colors.primary};
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  ${ModalButton} {
    width: calc(50% - 8px);
  }
`;
